<header class="masthead">
	<div class="navbar">
		<div class="col-sm-6 board-left-header">
      <button type="button" name="button" class="verification-back-btn" (click)="backToInbox()">
        <span>
          <svg style="margin-right:8px;" width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.24268 9.24261L1.00004 4.99997L5.24268 0.757334" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>Back</span>
      </button>
      <!-- <div class="workspace-option-area">
        <div class="form-field">
         <select class="options" >
          <option>{{workspaceTitle}}</option>
         </select>
        </div>
      </div> -->
		</div>
		<div class="col-sm-6 right-header">
      <div class="buttons-wrapper">
      <button class="btn btn-sm accept-btn" (click)="approveBoardBtn(1)" *ngIf="boardStatus == 'Pending' && !showLeaveLoader">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
            <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>
          </svg> Accept
      </button>

			<button class="btn btn-sm accept-btn-disable" *ngIf="boardStatus == 'Approved' || boardStatus == 'Rejected' && !showLeaveLoader">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
            <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>
          </svg> Accept
      </button>

			<button class="btn btn-sm accept-btn" *ngIf="boardStatus == 'Pending' && showLeaveLoader">
        <img src="assets/img/img-up-white.svg" alt="" style="height: 18px;">
      </button>

      <button class="btn btn-sm reject-btn" (click)="rejectBoardBtn(2)" *ngIf="boardStatus == 'Pending' && !showLeaveLoaderReject">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-x-circle" viewBox="0 0 16 16">
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
            </svg> Reject
      </button>

			<button class="btn btn-sm reject-btn-disable" *ngIf="boardStatus == 'Approved' || boardStatus == 'Rejected' && !showLeaveLoaderReject">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-x-circle" viewBox="0 0 16 16">
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
            </svg> Reject
      </button>

			<button class="btn btn-sm reject-btn" *ngIf="boardStatus == 'Pending' && showLeaveLoaderReject">
        <img src="assets/img/red-loader.gif" alt="" style="height: 15px;">
      </button>
		</div>
	</div>
</div>
</header>


<section>
	<div class="main-container">
		<div class="side-bar hide-sidebar" id="side-bar">
			<div class="left-sticky-bar" id="left-sticky-bar">
				<form class="custom-form search-area-field">
				<div class="side-search-box">
					<div class="search-box-side-bar" id="search-box" style="box-shadow:none">
						<button>
							<span role="img" aria-label="search" class=""><svg viewBox="64 64 896 896" focusable="false" class="" data-icon="search" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"></path></svg></span>
						</button>
					</div>
				</div>
				</form>
				<div class="side-bar-list-container">
          <div class="add-boards" style="margin-top:30px;">
            <h5>BOARDS</h5>
          </div>
					<div class="sidebar-list-group">
						<ul class="list-group" *ngFor="let board of boardApprovalList">
							<li class="selected-board-name-">
								<a (click)="boardlistClick(board.board_title, board.board_approval_id, board.workspace_title, board.status);">{{ board.board_title }}</a>
								<div class="dropdown-menu border-shadow border-radius-5">
									<ul class="list-group border-radius-5">
										<div class="seperator"></div>
										<li (click)="openDeleteBoardShare(board.id, board.title)"><a class="text-danger" href="javscript:;">Delete</a></li>
									</ul>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>

		<div class="center-container">
			<div>
				<div class="homepage-heading">
					<div class="homepage-heading_">
					<div class="homepage-heading-title">
            <h2>{{boardHeading}}</h2>
						<span class="user-illus-count">Assets ({{totalIllusCount}})</span>
					</div>

          <div class="ant-select ant-select-borderless ant-select-single ant-select-show-arrow home-switch-view-select d-flex">

            <div style="flex-grow: 1;"></div>

          </div>

						<div style="flex-grow: 1;"></div>
					</div>
					</div>
				</div>

				<div class="no-illus-img" *ngIf="totalIllusCount == 0">
					<img src="assets/img/empty_file_img.svg">
					<div><label>Add files to upload.</label></div>
				</div>


						<div class="illus-rollup-view row mb-5 mt-2">
						<ul class="new-board-media-list" *ngFor="let imges of imagesApprovalList">
							<li>
								<div class="inner-card">
									<div class="illus-img-container">
										<!-- <div class="img-type">
											<span>{{imges.image_format}}</span>
										</div> -->

										<video src={{imges.image}} *ngIf="imges.image_format == 'MP4' || imges.image_format == 'WEBM' || imges.image_format == 'FLV' || imges.image_format == 'WMV' || imges.image_format == 'MOV'" style="height: 184px;" controls></video>

										<img src="assets/img/psd.svg" alt="" *ngIf="imges.image_format == 'PSD'" style="height: 184px;">

										<img src={{imges.image}} *ngIf="imges.image_format == 'PNG' || imges.image_format == 'JPG'  || imges.image_format == 'SVG' || imges.image_format == 'JPEG' || imges.image_format == 'GIF' || imges.image_format == 'BMP'" style="height: 184px;">

										<img src={{imges.image_jpg}} *ngIf="imges.image_format == 'TIFF' || imges.image_format == 'WEBP'" style="height: 184px;">

										<img src="assets/img/ai-icon.svg" *ngIf="imges.image_format == 'AI'" style="height: 184px;">

										<img src="assets/img/EPS-icon.svg" *ngIf="imges.image_format == 'EPS'" style="height: 184px;">

										<img src="assets/img/zip-icon.svg" *ngIf="imges.image_format == 'ZIP'" style="height: 184px;">

										<pdf-viewer *ngIf="imges.image_format == 'PDF'" [src]="imges.image" style="width: 150px; height: 150px;" [original-size]="true" [render-text]="true" [rotation]="0"
										[show-all]="true" [fit-to-page]="true" [zoom]="1" [zoom-scale]="'page-width'"
										[stick-to-page]="true" [external-link-target]="'blank'" [autoresize]="true"
										[show-borders]="false" class="pdf-viewer" [show-all]="false" (page-rendered)="pageRendered()"></pdf-viewer>
									</div>

									<div class="hover-style">
										<div class="title"><b>{{ imges.title }}</b>
											<br>
											<span *ngIf="imges.size > 1000">{{imges.image_format}} - {{ imges.size/1000 }} MB</span>
											<span *ngIf="imges.size < 1000">{{imges.image_format}} - {{ imges.size }} KB</span>
										</div>
									</div>
								</div>
							</li>
						</ul>
					</div>

					<div class="loader-scenarios-success-msgs" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="200" *ngIf="sendSuccessful">
						<span class="ant-avatar-selected">
							<svg width="18" height="14" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M1 5L4.58824 9L13 1" stroke="#0fa636" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
						</span>
						<p>{{successMsg}}</p>
					</div>

					<div class="loader-scenarios-error-msgs" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="200" *ngIf="errorSuccessfull">
						<p>{{errorMsg}}</p>
					</div>
			</div>
		</div>
</section>

<div
	style="width: 100%;
	background-color: rgba(0,0,0, .9);
  padding-top:200px;"
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{'display':deleteBoardStyle}">
	<div class="modal-dialog-style modal-dialog-centered-style" role="document" style="height: 100px;
    width: 35%; margin: 0 auto; text-align: center;">
		<div class="modal-content" style="padding: 30px; background-color: rgb(255,255,255); border-radius: 10px;">
			<button style="text-align: end;" type="button" class="close" (click)="closeDeleteBoardShare()" data-dismiss="modal" aria-label="Close">
				<img src="assets/img/cross.svg" alt="download free illustrations">
			</button>
			<div class="modal-body">
				<img src="assets/img/delete_img.svg" alt="delete">
				<p></p>
				<br>
				<h3 style="margin-bottom:40px;">Delete {{deleteBoardName}}?</h3>
				<!-- <p style="margin-bottom:30px; margin-top:8px;">You'll not be able to recover it.</p> -->
				<div class="button-wrapper delete-leave-workspace">
					<a href="javascript:;" class="button cancel-dialog-btn" (click)="closeDeleteBoardShare()">Cancel</a>
					<a href="javascript:;" class="button google-login-btn" (click)="deleteBoard()">Delete</a>
				</div>
			</div>

		</div>
	</div>
</div>
